import type { Module } from 'vuex'
import { emailTemplateActions } from './actions'
import type { BeefreeTemplate, EmailTemplate, EmailTemplateState } from './types'
import type { RootState } from '@/store/modules/types'

export const initialEmailTemplateState = (): EmailTemplateState => ({
  libraryTemplates: [],
  libraryTemplatesCount: 0,
  isFetchingLibraryTemplates: false,
  savedTemplates: [],
  savedTemplatesCount: 0,
  isFetchingSavedTemplates: false,
})

interface TemplatesPage<T> {
  templates: T[]
  count: number
  append: boolean
}

const emailTemplateModule: Module<EmailTemplateState, RootState> = {
  namespaced: true,
  state: initialEmailTemplateState,
  actions: emailTemplateActions,
  getters: {
    hasMoreLibraryTemplates: state => state.libraryTemplates.length < state.libraryTemplatesCount,
    hasMoreSavedTemplates: state => state.savedTemplates.length < state.savedTemplatesCount,
  },
  mutations: {
    SET_LIBRARY_TEMPLATES(state, { templates, count, append }: TemplatesPage<BeefreeTemplate>) {
      state.libraryTemplates = append ? [...state.libraryTemplates, ...templates] : templates
      state.libraryTemplatesCount = count
    },
    SET_SAVED_TEMPLATES(state, { templates, count, append }: TemplatesPage<EmailTemplate>) {
      state.savedTemplates = append ? [...state.savedTemplates, ...templates] : templates
      state.savedTemplatesCount = count
    },
    PREPEND_SAVED_TEMPLATE(state, template: EmailTemplate) {
      state.savedTemplates = [template, ...state.savedTemplates]
      state.savedTemplatesCount += 1
    },
    SET_IS_FETCHING_LIBRARY_TEMPLATES(state, isFetching: boolean) {
      state.isFetchingLibraryTemplates = isFetching
    },
    SET_IS_FETCHING_SAVED_TEMPLATES(state, isFetching: boolean) {
      state.isFetchingSavedTemplates = isFetching
    },
  },
}

export default emailTemplateModule
